export default __webpack_public_path__ + "static/psgCard1-7aa03c0359827396d12711405729be3f.webp";